var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendEnabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7754 12.1134L0.676554 0.0590816C0.608045 0.020281 0.530476 -8.53813e-05 0.451541 2.69037e-07C0.372606 8.59194e-05 0.295061 0.0206206 0.226639 0.0595698C0.158216 0.098519 0.101299 0.154524 0.0615381 0.222005C0.0217774 0.289486 0.000551568 0.366096 0 0.444209V11.5357L8.73231 12.5015L0 13.4672V24.5558C0.000551568 24.6339 0.0217774 24.7105 0.0615381 24.778C0.101299 24.8455 0.158216 24.9015 0.226639 24.9404C0.295061 24.9794 0.372606 24.9999 0.451541 25C0.530476 25.0001 0.608045 24.9797 0.676554 24.9409L21.7754 12.8866C21.8437 12.8472 21.9004 12.7908 21.9398 12.723C21.9792 12.6551 22 12.5783 22 12.5C22 12.4217 21.9792 12.3449 21.9398 12.277C21.9004 12.2092 21.8437 12.1528 21.7754 12.1134Z",
    fill: "#FF8533"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEnabled);
export default __webpack_public_path__ + "static/media/sendEnabled.3ebb5f7912d9f349622cb6e80f1832e6.svg";
export { ForwardRef as ReactComponent };